import React from 'react'
import styles from './index.scss'

function Header() {
  return <div className={styles.header} />
}

export default Header
